import { Box, Grid, LinearProgress, TextField, Button } from '@material-ui/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import packageJson from '../../../package.json';
import { useOrganization } from '../../context/OrganizationContext';
import { useUser } from '../../context/UserContext';
import { loginService } from '../../services/customerService';

import { LoginCard, LoginCardContent } from './styles';

const Auth = () => {
	const history = useHistory();
	const { setUser } = useUser();
	const [username, setUsername] = useState('');
	const [usernameError, setUsernameError] = useState('');
	const [password, setPassword] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [loading, setLoading] = useState('');
	const { organization } = useOrganization();

	// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'field' implicitly has an 'any' type.
	const handleChange = field => ({ target }) => {
		if (field === 'username') {
			setUsernameError('');
			setUsername(target.value);
		}

		if (field === 'password') {
			setPasswordError('');
			setPassword(target.value);
		}
	};

	// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'evt' implicitly has an 'any' type.
	const handleKeyPress = evt => {
		if (evt.key === 'Enter') {
			login();
		}
	};

	async function login() {
		if (username.length === 0) {
			setUsernameError('Informe seu e-mail ou CPF');
			return;
		}
		if (password.length === 0) {
			setPasswordError('Informe sua senha');
			return;
		}
		// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
		setLoading(true);
		const [err, res] = await loginService(username, password);
		// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
		setLoading(false);

		if (err) {
			alert(err.message);
			return;
		}
		const customerGroups = res.signInUserSession.idToken.payload['cognito:groups'];
		// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'group' implicitly has an 'any' type.
		const hasPermission = customerGroups.some(group => group === 'Backoffice' || group === 'Admin');

		if (!hasPermission) {
			alert('Você não tem permissão para acessar o backoffice');
			return;
		}
		setUser(username);
		history.push('/home/usuarios');
	}

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			height="100vh"
		>
			<LoginCard>
				{loading && <LinearProgress />}

				<LoginCardContent>
					<Grid container justify="center" alignItems="center" direction="column" wrap="nowrap">
						<Box mb="36px">
							<img src={organization.imgUri} alt="logo" style={{ width: '120px' }} />
						</Box>

						<TextField
							fullWidth
							label="CPF"
							value={username}
							onChange={handleChange('username')}
							margin="normal"
							error={usernameError.length > 0}
							helperText={usernameError}
							onKeyPress={handleKeyPress}
						/>
						<TextField
							fullWidth
							label="Senha"
							value={password}
							onChange={handleChange('password')}
							type="password"
							margin="normal"
							error={passwordError.length > 0}
							helperText={passwordError}
							onKeyPress={handleKeyPress}
						/>
						<Box mt="64px" width="100%">
							<Button fullWidth color="primary" variant="contained" onClick={login}>
								Entrar
							</Button>
						</Box>
						<Box mt="24px">
							<span>
								{packageJson.version} - {process.env.REACT_APP_PUBLIC_ENV}
							</span>
						</Box>
					</Grid>
				</LoginCardContent>
			</LoginCard>
		</Box>
	);
};

export default Auth;
